import { useCallback, useState } from 'react';

import type { LegalDocumentType } from '@/features/auth/components/legal';

/**
 * Manages the open/closed state of the shared Terms of Service / Privacy Policy
 * popup. `document` stays set after `close()` so the popup can animate out with
 * its last content still rendered; `visible` drives the actual visibility.
 */
export function useLegalPopup() {
  const [document, setDocument] = useState<LegalDocumentType | null>(null);
  const [visible, setVisible] = useState(false);

  const open = useCallback((next: LegalDocumentType) => {
    setDocument(next);
    setVisible(true);
  }, []);

  const openTerms = useCallback(() => open('terms'), [open]);
  const openPrivacy = useCallback(() => open('privacy'), [open]);
  const close = useCallback(() => setVisible(false), []);

  return { document, visible, open, openTerms, openPrivacy, close };
}

export default useLegalPopup;
